import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var Features = require("lib/account/Features");
var CurrentUser = require("lib/account/CurrentUser");

var DataRouting = require("lib/routing/DataRouting");
var WidgetConfig = require('lib/widgets/WidgetsConfig')

var ReadingActions = require("lib/actions/ReadingActions");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var Spinner = require("components/utility/Spinner");
var EmptyState = require("components/data/EmptyState");
var PaginationControls = require("components/utility/PaginationControls");
var DataTable = require("components/data/subjects/shared/DataTable");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var Glyphicon = require("components/utility/icons/Glyphicon");
var QuizDisplay = require("components/writing/quizzes/QuizDisplay");

import moment from 'moment';

function reverseTimeZoneOffset(startDate, endDate) {
  // reverse the time zone offset pull all books based
  // on the user's time zone
  var currentUser = CurrentUser.get()
  if (currentUser.time_zone_offset) {
    var offset = -currentUser.time_zone_offset / (60 * 60);
  } else {
    var offset = 7 // default to Pacific time
  }

  startDate = moment(startDate).startOf('day').utcOffset(offset).format("YYYY-MM-DD")
  endDate = moment(endDate).endOf('day').utcOffset(offset).format("YYYY-MM-DD")

  return{ startDate, endDate }
}

function propsToConditions(props) {
  var conditions = _.pick(props,
    "startDate", "endDate", "textVariety", "textID", "userIDs", "readBook"
  );

  conditions.timeKey = "last_active_by_user_id";

  if (conditions.startDate && conditions.endDate) {
    var reversedTimeSpan = reverseTimeZoneOffset(conditions.startDate, conditions.endDate)
    conditions.startDate = reversedTimeSpan.startDate
    conditions.endDate = reversedTimeSpan.endDate
  }

  return conditions;
}

@connect(
  (state, props) => ({
    loading: ReadingSelectors.isLoadingBooks({ state, userIDs: props.userIDs }),
    books: ReadingSelectors.books({
      state,
      conditions: propsToConditions(props)
    }),
    showLogs: Features.isEnabled(Features.LOG_READING),
    showDigitalActivities: Features.isEnabled(Features.DIGITAL_EXERCISES),
    prefs: RosterSelectors.globalStudentListPrefs({ state })
  }),
  (dispatch, props) => ({
    populateData: () => {
      var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "readBook")
      
      if (conditions.startDate && conditions.endDate) {
        var reversedTimeSpan = reverseTimeZoneOffset(conditions.startDate, conditions.endDate)
        conditions.startDate = reversedTimeSpan.startDate
        conditions.endDate = reversedTimeSpan.endDate
      }

      var actionFunction = ReadingActions.fetchBookActivity
      var options = { embeds: ["book.quiz_evaluations", "book.log_sums", "book.answers", "book.reviews"], cache: true, fetchDetails: !props.skipPreloadDetails }
      new Promise(function (resolve, reject) {
        $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null)
      }).catch(() => console.log("Book activity failed to load"))
    },
    selectEvaluation: (textID, userID) => {
      return dispatch((dispatch, getState) => {
        return WritingSelectors.evaluationByUserTextType({
          state: getState(), subjectTextID: textID,
          subjectUserID: userID, subjectType: 'Quiz'
        });
      })
    },
    selectStudent: (studentID) => {
      return dispatch((dispatch, getState) => {
        return RosterSelectors.student({ state: getState(), id: studentID })
      })
    }
  })
)
@providePopulateData()
class DataBookTables extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = {
      bookChunks: _.chunk(_.sortBy(props.books, "max_last_active").reverse(), DataRouting.PER_PAGE),
      currentPage: 1,
      totalCount: _.size(props.books)
    }
  }

  // changes location on the data table
  // saves current location state for users to come back
  changeLocationState(subjectType, subjectID, controlMode) {
    var newLocationState = { ...this.props.locationState }
    newLocationState.subjectType = subjectType
    
    if (subjectType == DataRouting.SUBJECT_QUIZZES) {
      newLocationState.quizID = subjectID
    } else {
      newLocationState.textID = subjectID
    }

    if (controlMode) {
      newLocationState = { ...newLocationState, controlMode }
    }

    this.props.updateRoute(newLocationState)
  }

  onPageChange(page) {
    this.setState({ currentPage: page });
  }

  formatDate(date) {
    return $wr.formatDate(date, "MM/DD/YY")
  }

  // hides score for free user until they manually enter it
  hideAutograderScore(evaluation) {
    return !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score
  }

  // checks user id and book with read_book filter
  readBookFilterMatches(book, user_id) {
    var { readBook } = this.props
    
    if (!readBook) { return true }
    if (readBook == 'yes' && book.read_book_yes && book.read_book_yes[user_id]) { return true }
    if (readBook == 'no' && book.read_book_no && book.read_book_no[user_id]) { return true }
  }

  // link that sends user to quiz view with edit tab open
  renderGradeQuizLink(quizID, linkText) {
    return (
      <a onClick={() => this.changeLocationState(DataRouting.SUBJECT_QUIZZES, quizID, EDIT_CONTROLS)} className='gradeQuizLink'>
        {linkText}
      </a>
    )
  }

  buildWritingItem(stat, title, subjectType, subjectID) {
    return (
      <div key={`${title}_${subjectID}`} className="writingItem">
        <span className="itemSubject">{title}:</span>
        <span className="itemStat">{stat}</span>
        <a className='hideOnPrint' onClick={() => this.changeLocationState(subjectType, subjectID)}>
          <Glyphicon icon="new-window" />
        </a>
      </div>
    )
  }

  // returns counts of answers and reviews
  // completed by student (TODO: add question builders and exercises)
  writingCells(book, userID) {
    var writingCountElements = []

    if (book['answer_counts'] && book['answer_counts'][userID]) {
      var title = book['answer_counts'][userID] > 1 ? 'Answers' : 'Answer'
      var subjectType = DataRouting.SUBJECT_ANSWERS
      writingCountElements.push(this.buildWritingItem(book['answer_counts'][userID], title, subjectType, book.text_id))
    }

    if (book['review_counts'] && book['review_counts'][userID]) {
      var title = book['review_counts'][userID] > 1 ? 'Reviews' : 'Review'
      var subjectType = DataRouting.SUBJECT_REVIEWS
      writingCountElements.push(this.buildWritingItem(book['review_counts'][userID], title, subjectType, book.text_id))
    }

    return writingCountElements
  }

  generateBookRows(books) {
    var rows = []
    _.each(books, book => {

      var { user_ids, last_actives, text_id, title, lexile_score } = book

      _.each(user_ids, user_id => {
        // continue loop if read book filter doesn't match
        // albus sends one response per book, so we have to check
        // user id against read_book filter
        if (!this.readBookFilterMatches(book, user_id)) { return }
        // student information
        var student = this.props.selectStudent(user_id)
        // quiz evaluaiton for book
        var quizEvaluation = this.props.selectEvaluation(text_id, user_id)              
        var writingCells = this.writingCells(book, user_id)

        // a quiz is required in order to determine if the
        // student read the book or not
        if (!_.isEmpty(writingCells)) {
          var writingValue = (
            <div className="writingContainer">
              {writingCells}
            </div>
          )
        }
        
        if (quizEvaluation && this.hideAutograderScore(quizEvaluation)) { 
          var readTheBook = this.renderGradeQuizLink(quizEvaluation.subject_id, 'Grade Quiz')
          var readBookColumnClass = 'readBookColumn-EmptyState'
        } else if (quizEvaluation) {
          // quiz score
          var stat = <ScoreDisplay evaluationID={quizEvaluation.id} mode={ScoreDisplay.SCORE_ONLY_MODE} />
          var writingValue = (
            <div className="writingContainer">
              {this.buildWritingItem(stat, 'Quiz Score', DataRouting.SUBJECT_QUIZZES, quizEvaluation.subject_id)}
              {writingCells}
            </div>
          )
          
          if (quizEvaluation.read_book) {
            var readTheBook = quizEvaluation.read_book
            var readBookColumnClass = 'readBookColumn'
            var confidence = quizEvaluation.read_book_confidence
          } else {
            var readTheBook = this.renderGradeQuizLink(quizEvaluation.subject_id, 'Complete Grade')
            var readBookColumnClass = 'readBookColumn-EmptyState'
          }
          
        } else {
          var readTheBook = 'Quiz Pending'
          var readBookColumnClass = 'readBookColumn-Pending'
        }

        var bookTitle = lexile_score ? `${title} (L: ${lexile_score})` : title

        var row = [
          {
            // date column
            value: this.formatDate(last_actives[user_id]),
            classes: ['no-wrap', 'dateColumn']
          },
          {
            // student name column
            value: student.display_name,
            classes: ['studentNameColumn'],
          },
          {
            // book title column
            value: bookTitle,
            classes: ['pre-wrap', 'italic', 'bookTitle']
          },
          {
            // displays if the student read the book based on
            // totality of writing data for book
            value: readTheBook,
            classes: ['no-wrap', readBookColumnClass, 'extraWidth'],
            confidence: confidence,
            book_answers_analysis_column: true,
            expanded_content: { component: 'BookAnswersAnalysis', component_props: { textID: text_id, userID: user_id } }
          },
          {
            // shows all writing done for a book
            value: writingValue,
            classes: ['no-wrap', 'writingColumn'],
          },
        ]
        rows.push(row)
      })
    })
    return rows
  }

  renderPagination() {
    if (this.state.totalCount) {
      return (
        <PaginationControls page={this.state.currentPage}
          perPage={DataRouting.PER_PAGE}
          totalCount={this.state.totalCount}
          onPageChange={this.onPageChange} />
      );
    }
  }

  renderBooksTable() {
    if (this.props.loading) {
      return <Spinner />
    } else if (this.state.totalCount) {
      var books = this.state.bookChunks[this.state.currentPage - 1]
      return (
        <DataTable
          subjectType='books'
          columnHeaders={QUIZ_TABLE_HEADERS}
          rows={this.generateBookRows(books)}
          printable={false}
        />
      )
    } else {
      return <EmptyState type={BOOKS} />
    }
  }

  // renders hidden component used for printing
  // without pagination
  renderPrintableBooksTable() {
    var { books, loading } = this.props
    if (books && !loading) {
      var books = _.flatten(this.state.bookChunks)
      return (
        <DataTable
          subjectType='books'
          columnHeaders={QUIZ_TABLE_HEADERS}
          rows={this.generateBookRows(books)}
          printable={true}
        />)
    }
  }

  renderLoading() {
    if (this.props.loading) {
      return <Spinner />
    }
  }

  render() {
    return (
      <div className="dataBookTables">
        {this.renderPagination()}
        {this.renderBooksTable()}
        {this.renderPrintableBooksTable()}
        {this.renderPagination()}
      </div>
    )
  }

  componentDidUpdate(prevProps) {
    if (this.props.books !== prevProps.books) {
      this.setState({
        bookChunks: _.chunk(_.sortBy(this.props.books, "max_last_active").reverse(), DataRouting.PER_PAGE),
        currentPage: 1,
        totalCount: _.size(this.props.books)
      })
    }
  }
}

var BOOKS = "books";
var QUIZ_TABLE_HEADERS = ['Date', 'Student', 'Title', 'Read Book', 'Writing']
var EDIT_CONTROLS = "Edit";

DataBookTables.WrappedComponent.propTypes = PageStrictPropTypes({
  // Data from above
  userIDs: PropTypes.array,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  showFullData: PropTypes.bool,
  textVariety: PropTypes.string,
  textID: PropTypes.string,
  readBook: PropTypes.string,
  prefs: PropTypes.object,

  byStudent: PropTypes.bool,
  booksAmount: PropTypes.number,
  showLogs: PropTypes.bool,
  showDigitalActivities: PropTypes.bool,
  skipPreloadDetails: PropTypes.bool,
  softMaxPerTable: PropTypes.number,
  locationState: PropTypes.object,
  prevLocationState: PropTypes.object,
  updateRoute: PropTypes.func,

  // Data from @connect
  loading: PropTypes.bool,
  books: PropTypes.array,
  studentList: PropTypes.string,

  // Handlers from @connect
  populateData: PropTypes.func,
  selectEvaluation: PropTypes.func,
  selectStudent: PropTypes.func,
})

module.exports = DataBookTables;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataBookTables.js